import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const KnowledgeSourceListForNRO = lazy(() =>
  import("@scenes/KnowledgeSourceList").then((module) => ({
    default: module.KnowledgeSourceList,
  }))
);

export const knowledgeSourceNRO: NavigationRoutingObject = {
  Component: KnowledgeSourceListForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  icon: "nav-system-braze-documentation",
  heading: (t: I18nT<"dashboard-navigation">) => t("knowledge-source-nro-heading", "Knowledge Sources"),
  pageNameForTracking: () => "Knowledge Sources",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("knowledge-source-nro-description", "Create and manage knowledge sources for your AI agents"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("agent_console_knowledge_source") &&
      hasPermission("appGroup", { permission: "viewKnowledgeSources" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
